export const GenderTypes: Gender[] = ['male', 'female'];
